var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrandedALower(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 43,
    viewBox: "0 0 49 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_420_230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.28125 29.8868C0.28125 29.8868 11.0376 17.7119 24.3061 17.7119C37.5746 17.7119 48.3309 29.8868 48.3309 29.8868C48.3309 29.8868 37.5746 42.0617 24.3061 42.0617C11.0376 42.0617 0.28125 29.8868 0.28125 29.8868Z",
    fill: "#E8DFD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.447 24.8323C40.447 24.8323 40.5192 18.6654 40.5192 17.7988C40.5192 8.55573 34.744 5.7828 30.8024 5.7828H7.3262L5.11719 0.00585938H34.744C42.0207 1.03127 48.3446 6.56269 48.3446 17.64V42.062H40.447V24.8323Z",
    fill: "#E8DFD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3057 36.3858C27.8939 36.3858 30.8028 33.4761 30.8028 29.8868C30.8028 26.2974 27.8939 23.3877 24.3057 23.3877C20.7174 23.3877 17.8086 26.2974 17.8086 29.8868C17.8086 33.4761 20.7174 36.3858 24.3057 36.3858Z",
    fill: "#0268A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3047 36.2557C27.8211 36.2557 30.6718 33.4042 30.6718 29.8867C30.6718 26.3691 27.8211 23.5176 24.3047 23.5176C20.7882 23.5176 17.9375 26.3691 17.9375 29.8867C17.9375 33.4042 20.7882 36.2557 24.3047 36.2557Z",
    fill: "#0268A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_420_230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.0641,
    height: 42.0561,
    fill: "white",
    transform: "translate(0.28125 0.00585938)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandedALower);
export default __webpack_public_path__ + "static/media/branded-a-lower.6a5825682373f92320df2c40cd6e5694.svg";
export { ForwardRef as ReactComponent };